import type {Rect} from '@wix/document-services-types'
import {DomOrderStrategy} from '../../enums'
export const compareByZRules = (rectA: Rect, rectB: Rect, isRtl: boolean) => {
    return rectA!.y - rectB!.y || (isRtl ? rectB!.x - rectA!.x : rectA!.x - rectB!.x)
}

import {getStructurePointer, getTargetLayoutPointer} from '../../conversionDal/utils/pointer'
import type {ConversionDal} from '../../types'
import {SemanticTypes} from '../../preprocess/conversionDataBuilders'

const SEMANTIC_TYPE_PRIORITY: Partial<Record<SemanticTypes, number>> = {
    [SemanticTypes.LOGO]: -1,
    [SemanticTypes.MENU]: 1
}
export const sortHeaderContainerChildren = (conversionDal: ConversionDal) => (childIdA: string, childIdB: string) => {
    const getPriority = (id: string) => {
        const semanticType = conversionDal.get(getStructurePointer({id}))?.semanticType
        return SEMANTIC_TYPE_PRIORITY[semanticType as SemanticTypes] ?? 0
    }

    const isFirstRow = (id: string) => {
        const layout = conversionDal.get(getTargetLayoutPointer({id}))
        const {itemLayout} = layout ?? {}
        return itemLayout?.gridArea?.rowStart === 1
    }

    const isFirstRowA = isFirstRow(childIdA)
    const isFirstRowB = isFirstRow(childIdB)

    // Prioritize row 1 components over others
    if (isFirstRowA && !isFirstRowB) return -1
    if (!isFirstRowA && isFirstRowB) return 1

    // If both are in the same row group, use existing priority logic
    return getPriority(childIdA) - getPriority(childIdB)
}

export const compareByNRules = (rectA: Rect, rectB: Rect, isRtl: boolean) => {
    return (isRtl ? rectB!.x - rectA!.x : rectA!.x - rectB!.x) || rectA!.y - rectB!.y
}

export const shapeRules: Record<DomOrderStrategy, (rectA: Rect, rectB: Rect, isRtl: boolean) => number> = {
    [DomOrderStrategy.NShape]: compareByNRules,
    [DomOrderStrategy.ZShape]: compareByZRules
}

export const generatePinnedChildLayout = () => ({
    itemLayout: {
        type: 'GridItemLayout',
        alignSelf: 'start',
        justifySelf: 'start',
        gridArea: {
            rowStart: -1,
            rowEnd: 1,
            columnStart: -1,
            columnEnd: 1
        },
        pinnedToContainer: true
    }
})

export const generateChildLayout = (startRow: number) => ({
    itemLayout: {
        type: 'GridItemLayout',
        alignSelf: 'start',
        justifySelf: 'start',
        gridArea: {
            rowStart: startRow,
            rowEnd: startRow + 1,
            columnStart: 1,
            columnEnd: 2
        }
    }
})

export const generateHeaderContainerLayout = (rows: number, columns: number) => ({
    rows: Array(rows).fill({type: 'minContent'}),
    columns: Array(columns).fill({type: 'fr', value: 1}),
    type: 'GridContainerLayout'
})

export const generateContainerLayout = (rows: number) => ({
    rows: Array(rows).fill({type: 'minContent'}),
    columns: [{type: 'fr', value: 1}],
    type: 'GridContainerLayout'
})
